import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['p', 'h3', 'h4', 'strong', 'em', 'u', 's', 'ol', 'ul', 'li', 'a', 'br'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

export const sanitizeHTML = (html: string): string => {
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });

  // Ensure all links have target="_blank" and rel="noopener"
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = clean;
  
  const links = tempDiv.querySelectorAll('a');
  links.forEach(link => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener');
  });

  return tempDiv.innerHTML;
};
